import Util from 'root/module/util';
import Modals from 'root/modals';
import Cache from 'root/cache';
import View from 'view/base';
import View_Code_Install_Verify from 'view/project/code_install_verify';

export default View.extend({
    installed_domains: null,

    views: {
        code_verify: {}
    },

    events: {
        'click .project-domain-view'   : 'viewProjectDomain',
        'click .project-member'        : 'viewProjectMember',
        'click .project-star'          : 'onProjectStar',
        'click .project-domain-add'    : 'onAddProjectDomain',
        'click .install-code'          : 'onInstallCode',
        'click .manage-domains'        : 'onManageDomains'
    },

    dom_handlers: {
        onInstallCode: function(e) {
            Modals.getWidgetCode(false);
        },

        viewProjectDomain: function(e) {
            var project_domains = Cache.project_domain.where({project_id: this.model.id});

            if (project_domains.length === 0) {
                return;
            }

            if (Cache.app.isAdmin()) {
                Modals.editProjectDomains(this.model.id);
            } else {
                Modals.viewProjectInfo(this.model.id, 'about');
            }
        },

        viewProjectMember: function(e) {
            Modals.viewProjectInfo(this.model.id, 'members');
        },

        onProjectStar: function(e) {
            var starred_project_ids = Cache.app.getUserSetting('project_starred');

            if (!starred_project_ids) {
                starred_project_ids = [];
            } else {
                starred_project_ids = starred_project_ids.split(',').map(Number);
            }

            var is_starred = starred_project_ids.indexOf(this.model.id) !== -1;

            if (is_starred) {
                starred_project_ids.splice(starred_project_ids.indexOf(this.model.id), 1);
            } else {
                starred_project_ids.push(this.model.id);
            }

            Cache.app.addUserSetting('project_starred', starred_project_ids.join(','));

            this.$el.find('.project-star').attr('data-starred', is_starred ? 0 : 1);
            this.$el.find('.settings-star').text(is_starred ? 'Add to Favorites' : 'Undo Favorite');

            // reset cache
            Cache.project.resetSortCache();
        },

        onAddProjectDomain: function(e) {
            if (!Cache.app.isAdmin()) {
                return;
            }

            e.stopPropagation();
            Modals.editProjectDomains(this.model.id);
        },

        onManageDomains: function(e) {
            e.preventDefault();
            Modals.editProjectDomains(this.model.id);
        }
    },

    initialize: function() {
        this.model  = Cache.getDefaultProject();
        this.widget = Cache.widget.findWhere({project_id: this.model.id});
        this.survey = Cache.survey.findWhere({project_id: this.model.id});

        this.views.code_verify = new View_Code_Install_Verify({
            project_id: this.model.id
        });

        this.listenTo(Cache.project_domain, 'add remove', this.render);
        this.listenTo(this.model, 'change:name', this.render);
        this.listenTo(Cache.portal, 'add', this.render);

        if (this.model.isFeedback()) {
            this.listenTo(this.widget, 'change:is_active',  this.render);
        } else {
            this.listenTo(this.survey, 'change:is_active',  this.render);
            this.listenTo(this.survey, 'change:start_time', this.render);
            this.listenTo(this.survey, 'change:end_time',   this.render);
        }
    },

    loadInstallDomains: function() {
        Cache.app.request({
            action: 'js_snippet/getCodeInstallDomain',
            success: (response) => {
                this.installed_domains = response.domains;
                this.renderProjectInfo();
            }
        });
    },

    renderProjectInfo: function() {
        var project_domains = Cache.project_domain.where({project_id: this.model.id});
        var domains_total   = project_domains.length;
        var members_total   = Cache.app.getUsersByProject(this.model.id).length;
        var installed_count = 0;

        if (this.installed_domains) {
            project_domains.map((model) => {
                var is_installed = this.installed_domains.some((domain) => {
                    return Util.matchDomain(domain, model.get('domain'));
                });

                if (is_installed) {
                    installed_count++;
                }
            });
        }

        var content = '';
        // domains
        if (domains_total === 0) {
            content +=
            '<span class="project-domain project-domain-add text-warning tooltip" data-title="Project Domains">' +
                '<span class="project-domain-view">' +
                    '<i class="fa-solid fa-triangle-exclamation text-warning margin-right-8"></i>Add domains' +
                '</span>' +
            '</span>';
        } else if (domains_total > installed_count && this.installed_domains) {
            content +=
            '<span class="project-domain">' +
                '<span class="project-domain-view">' +
                    '<i class="fa-solid fa-triangle-exclamation text-warning margin-right-8"></i>' +
                    '<span class="dashed-underline-warning">' +
                        project_domains[0].escape('domain') +
                        (domains_total > 1 ? ' & ' + (domains_total - 1) + ' more' : '') +
                    '</span>' +
                '</span>' +
                '<div class="project-domain-install-status">' +
                    '<div class="margin-bottom-16 font-weight-semibold">Install Userback on your project domains</div>' +
                    project_domains.map((model) => {
                        var is_installed = this.installed_domains.some((domain) => {
                            return Util.matchDomain(domain, model.get('domain'));
                        });

                        return '' +
                        '<div class="domain">' +
                            '<div class="margin-bottom-8 ellipsis">' + (model.get('domain').startsWith('http') ? '' : 'https://') + model.escape('domain') + '</div>' +
                            (is_installed ?
                            '<div class="text-success font-weight-medium"><i class="fa-solid fa-circle-check"></i> Verified</div>' :
                            '<div class="text-warning font-weight-medium"><i class="fa-solid fa-triangle-exclamation"></i> Code not found</div>') +
                        '</div>';
                    }).join('') +

                    '<div class="margin-top-16">' +
                        '<button type="button" class="install-code small tertiary margin-right-8">View Code</button>' +
                    '</div>' +
                    (Cache.app.isAdmin() ?
                    '<div class="margin-top-16 text-info">No longer using a domain? <a href="#" class="manage-domains primary font-weight-medium">Manage domains</a></div>' : '') +
                '</div>' +
            '</span>';
        } else {
            content +=
            '<span class="project-domain tooltip" data-title="Project Domains">' +
                '<span class="project-domain-view">' +
                    '<i class="fa-solid fa-circle-info text-icon margin-right-8"></i>' +
                    project_domains[0].escape('domain') +
                    (domains_total > 1 ? ' & ' + (domains_total - 1) + ' more' : '') +
                '</span>' +
            '</span>';
        }

        // members
        content +=
        '<span class="project-member tooltip" data-title="Project Members">' + members_total + ' member' + (members_total === 1 ? '' : 's') + '</span>';

        this.$el.find('.project-info').html(content);

        if (project_domains.length && !this.installed_domains) {
            this.loadInstallDomains();
        }
    },

    render: function() {
        var is_starred = Cache.app.getUserSetting('project_starred') && Cache.app.getUserSetting('project_starred').split(',').map(Number).indexOf(this.model.id) !== -1;

        var content =
        '<div>' +
            '<h1 class="project-title">' +
                '<span class="project-name">' + this.model.escape('name') + '</span>' +
                '<span class="project-star" data-starred="' + (is_starred ? 1 : 0) + '">' +
                    '<i class="fa-solid fa-star-sharp tooltip" data-title="Starred"></i>' +
                    '<i class="fa-regular fa-star-sharp tooltip" data-title="Not Starred"></i>' +
                '</span>' +
            '</h1>' +
            '<div class="project-info"></div>' +
        '</div>';

        this.$el.html(content);

        this.renderProjectInfo();

        return this;
    }
});